import { useContext } from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react-lite'

import { AlmanacEditorStateContext } from 'stores/EditorState'
import { TEXT_STYLES } from 'common/Prose/constants'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { setBlockType } from 'common/Prose/Commands/setBlockType'

import Styles from './TextStyleSelection.module.scss'
import { SelfScrollingButton } from '../components/utils/SelfScrollingButton'

export const TextStyleSelection = observer(() => {
  const view = useEditorView()

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { activeStyles } = useContext(AlmanacEditorStateContext)!

  const onSelect = (key: string) => () => {
    setBlockType(key)(view.state, view.dispatch)
  }

  return (
    <div className={Styles.textStyleSelection}>
      {Object.entries(TEXT_STYLES).map(([key, { textValue }]) => (
        <SelfScrollingButton
          isActive={activeStyles.has(key)}
          aria-label={textValue}
          key={key}
          className={cx(Styles.textStyleSelectionItem, { [Styles.activeItem]: activeStyles.has(key) })}
          onClick={onSelect(key)}
          data-testid={`mobile-toolbar-text-style-${key}`}
        >
          {textValue}
        </SelfScrollingButton>
      ))}
    </div>
  )
})
